



















import Vue from "vue";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export default Vue.extend({
    props: {
        clientUser: {
            type: ClientUser,
            required: true,
        },
    },
});
